var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQaOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_6505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 6.90601L14.1203 22.1327L8.46699 16.4793L10.347 14.5993L14.1203 18.3727L27.4537 5.03935L29.3337 6.90601ZM26.387 13.626C26.5603 14.386 26.667 15.186 26.667 15.9993C26.667 21.8927 21.8937 26.666 16.0003 26.666C10.107 26.666 5.33366 21.8927 5.33366 15.9993C5.33366 10.106 10.107 5.33268 16.0003 5.33268C18.107 5.33268 20.0537 5.94602 21.707 6.99935L23.627 5.07935C21.467 3.55935 18.8403 2.66602 16.0003 2.66602C8.64033 2.66602 2.66699 8.63935 2.66699 15.9993C2.66699 23.3593 8.64033 29.3327 16.0003 29.3327C23.3603 29.3327 29.3337 23.3593 29.3337 15.9993C29.3337 14.4127 29.0403 12.8927 28.5337 11.4793L26.387 13.626Z",
    fill: "#203662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_6505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaOk);
export default __webpack_public_path__ + "static/media/qa-ok.a6584fc5afac7795fd3c9003ba86b870.svg";
export { ForwardRef as ReactComponent };